import { FC, SVGProps } from 'react';
import type { IconName } from '../../iconLoader';
import type { TagProps } from '../../tag';

export type ComponentSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type SelectMenuItemVariant = 'normal' | 'destruct';
export interface SelectMenuItem {
    icon?: FC<SVGProps<SVGSVGElement>>;
    /** A DS icon, drawn through IconLoader so it fits its 16px box. Wins over `icon`. */
    iconName?: IconName;
    value: string;
    label?: string;
    id: string;
    isSelected: boolean;
    isDisabled?: boolean;
    onClick?: () => void;
    testId?: string;
    variant?: SelectMenuItemVariant;
    actionIcon?: IconName;
    actionLabel?: string;
    actionPressed?: boolean;
    onAction?: (item: SelectMenuItem) => void;
    tags?: TagProps[];
}

export interface eventTypeDefinition {
    stopPropagation: () => void;
    target: { id: string; checked: boolean };
}

// pointer-events-none: the checkbox is a disabled, decorative input, so a click must land on its row.
export const checkboxClass =
    'pointer-events-none mr-2 bg-system-surface-container checked:bg-system-primary checked:text-system-on-primary border border-solid border-system-outline focus:ring-0 focus:outline-none';
export const itemContainerClass = 'flex items-center justify-between w-full';
export const contentContainerClass = 'flex flex-col flex-grow ml-2';
export const disabledItemClass = 'opacity-50 cursor-default pointer-events-none';
export const enabledItemClass = 'opacity-100 cursor-pointer';
